<div class="flex items-stretch justify-between gap-12 children:w-1/2 children:flex-1 ">
  <app-card>
    <div class="flex flex-col p-4">
      <div class="flex flex-row justify-between pb-4">
        <h5 id="h5-ballot-summary">Ballot Summary</h5>
        <app-ballot-status-badge [statusId]="sdBallotDetail?.unifiedBallotStatusId"></app-ballot-status-badge>
      </div>
      <div class="flex flex-col lg:gap-4 lg:flex-row lg:children:w-1/2">
        <div class="flex flex-col">
          <div id="div-sd-ballot-project-type">
            <label for="p-sd-ballot-project-type">Project Type</label>
            <p class="body-default-regular" id="p-sd-ballot-project-type">
              {{ sdBallotDetail?.projectType }}
            </p>
          </div>

          <div id="div-sd-ballot-project-number">
            <label for="p-sd-ballot-project-number">Project Number</label>
            <p class="body-default-regular" id="p-sd-ballot-project-number">
              {{ sdBallotDetail?.projectNumber }}
            </p>
          </div>

          <div id="div-sd-ballot-committee">
            <label for="p-sd-ballot-committee">Committee</label>
            <p class="body-default-regular">
              <a class="body-default-regular text-link" id="p-sd-ballot-committee"
                [routerLink]="['/committees', sdBallotDetail?.committeeCode]">
                {{ sdBallotDetail?.committeeCode }}
                {{ sdBallotDetail?.committeeTitle }}
              </a>
            </p>
          </div>

          <div id="div-sd-ballot-project-manager">
            <label for="a-sd-ballot-project-manager">Lead</label>
            <p class="body-default-regular">
              <a class="body-default-regular text-link" id="a-sd-ballot-project-manager"
                href="mailto:{{ sdBallotDetail?.committeeProjectManagerEmail }}">
                {{ sdBallotDetail?.committeeProjectManagerName }}
              </a>
            </p>
          </div>

        </div>

        <div class="flex flex-col">
          <div id="div-sd-ballot-start-date">
            <label for="p-sd-ballot-start-date">Start Date</label>
            <p class="body-default-regular" id="p-sd-ballot-start-date">
              {{ sdBallotDetail?.ballotStartDate | dateFormat }}
            </p>
          </div>
          <div id="div-sd-ballot-end-date">
            <label for="p-sd-ballot-end-date">End Date</label>
            <p class="body-default-regular" id="p-sd-ballot-end-date">
              {{ sdBallotDetail?.ballotEndDate | dateFormat }}
            </p>
          </div>
        </div>
      </div>

      <div class="my-4 border-b border-gray-200"></div>

      <form [formGroup]="ballotFormGroup">
        <div class="flex flex-col children:w-full">
          <label for="sd-ballot-note">Notes</label>
          <div *ngIf="!isPmOrAbove" class="ballot-summary-value">{{ballotNoteCtrl?.value??''}}</div>
          <app-text-area *ngIf="isPmOrAbove" id="sd-ballot-note" title="Note" formControlName="ballotNoteCtrl" [rows]="6"></app-text-area>
        </div>
      </form>


        <div class="my-4 border-b border-gray-200"></div>

        <div *ngIf="!isPmOrAbove && isVotingActionsVisible">

          <div class="mb-4 body-default-bold">My Vote</div>
          <div *ngIf="!hasVoted">No vote placed</div>

          <div *ngIf="hasVoted" class="flex flex-row items-center">
            <span class="mr-2 material-symbols-rounded" [ngStyle]="{ color: userVoteOption?.color }">{{
              userVoteOption?.icon }}</span>
            <span class="body-default-bold">{{ userVoteOption?.text }}</span>
            <span>&nbsp;-&nbsp;placed on {{ userVoteSubmittedDate }}</span>
          </div>
        </div>

        <div id="voting-action" class="flex flex-row justify-between gap-4 mt-4">
          <button *ngIf="showCommentBtn" class="w-2/8 btn btn-primary h-[50px]" id="courtesy-comment-btn"
            (click)="openNonEligibleCommentModal()">
            Comment
          </button>

          <button *ngIf="!isPmOrAbove && isVotingActionsVisible && !isInternalPublicUser" class="w-2/8 btn btn-primary h-[50px]" [disabled]="!isVoteButtonEnable" id="place-vote-Button"
            (click)="openPlaceVoteModal()">
            {{ hasVoted ? "Change Vote" : "Place Vote" }}
          </button>

          <button id="download-draft" type="button"  class="w-2/8 btn btn-primary h-[50px]" [disabled]="!draftDocument"
            (click)="downloadDraft()" >
            Download Draft
          </button>
        </div>
      </div>

  </app-card>
  <app-card>
    <div class="flex flex-col w-full">
      <app-sd-eligible-voters [ballotVotes]="ballotVotes" [isJoint]="sdBallotDetail?.isJoint??false"
        [sdBallotStatus]="sdBallotDetail?.unifiedBallotStatusId"
        [projectId]="projectId"
        [designation] = "designation"
        (onFinalisedBallot)="onFinalisedBallot.emit($event)"
      ></app-sd-eligible-voters>
    </div>
  </app-card>
</div>
